import { render, staticRenderFns } from "./Preregistro.vue?vue&type=template&id=6516869c&scoped=true"
import script from "./Preregistro.vue?vue&type=script&lang=js"
export * from "./Preregistro.vue?vue&type=script&lang=js"
import style0 from "./Preregistro.vue?vue&type=style&index=0&id=6516869c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6516869c",
  null
  
)

export default component.exports